import { Memoize, parseIfString } from '@springbokagency/stencil-base';
import { Component, Host, h, Prop, Listen, State } from '@stencil/core';
import { FaqSectionData } from './faq-section.types';
import state from '../../../store/store';
import { IconName } from '../../atoms/icon/icon.types';

/**
 * FAQ Section.
 */
@Component({
  tag: 'efb-faq-section',
  styleUrl: 'faq-section.scss',
  shadow: true,
})
export class EfbFaqSection {
  @State() itemsLength: number = 6;

  @State() loadMoreLoading: boolean = false;

  /**
   * Component's data.
   */
  @Prop() data: FaqSectionData | string;

  @Memoize('data')
  get parsedData(): FaqSectionData {
    return parseIfString(this.data);
  }

  /**
   * Events
   */

  @Listen('efbButtonClick')
  onEfbButtonClick(e: CustomEvent) {
    const { action } = e.detail;

    if (action === 'load-more-faq') {
      this.loadMoreLoading = true;

      setTimeout(() => {
        this.itemsLength = this.parsedData.items.length;
        this.loadMoreLoading = false;
      }, 300);
    }
  }

  render() {
    const { suptitle, title, text, items } = this.parsedData;

    return (
      <Host>
        <div class="faq-section">
          <div class="container">
            <div class="head">
              <efb-title-bar
                class="suptitle"
                text={suptitle}
                tag="h2"
                variant="purple"
                bottomMargin="sm"
              />
              <efb-title class="title" text={title} tag="h3" size="sm" bottomMargin="md" bold />
              <efb-paragraph class="content" text={text} size="md" bottomMargin="lg" />
            </div>
            <div class="body">
              <ul class="faq-items">
                {items.slice(0, this.itemsLength).map((item) => (
                  <efb-click-action
                    class="faq-items-el"
                    tagClass="faq-item"
                    name="open-video-modal"
                    value={{
                      videoGroupId: item.videoGroupId,
                      videoId: item.videoId,
                    }}
                    dataAnalytics={item.dataAnalytics}
                  >
                    <div class="faq-item-body">
                      <div class="faq-item-title">{item.title}</div>
                      <div class="faq-item-text">{item.text}</div>
                    </div>
                    <div class="faq-item-foot">
                      <div class="faq-item-label">{item.ctaText}</div>
                      <efb-icon class="faq-item-icon" name={IconName.playCircleOutlined}></efb-icon>
                    </div>
                  </efb-click-action>
                ))}
              </ul>

              {this.itemsLength < items.length && (
                <div class="buttons">
                  <efb-button
                    text={state.currentLanguage === 'nl' ? 'Laad meer' : 'Charger plus'}
                    variant="purple"
                    action="load-more-faq"
                    isLoading={this.loadMoreLoading}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
